// Set the $ variable for WP
var $ = jQuery;


// Start AaltoMation
 $(window).scroll(function(){
	 inViewport();
 });

 $(window).resize(function(){
	 inViewport();
 });

 var h = window.innerHeight;

 function inViewport(){
	 

	 $('.aaltomation').each(function(){
		var divPos = $(this).offset().top,
 		topOfWindow = $(window).scrollTop();
		if( divPos < topOfWindow+h-100 ){
			var animationClass = $(this).data('animation-in')
			$(this).removeClass('aaltomation');
			$(this).addClass('animate__animated');
			$(this).addClass(animationClass);
		}

		if( divPos < 100 ){
			console.log('gone');
		}
	 });
 }

console.log('Aaltomation Has Loaded');
// End AaltoMation

$( document ).ready(function() {
	if ($('.splide').length > 0) {
		

		var splide = new Splide( '.splide' ).mount( window.splide.Extensions );

		splide.on( 'move', function () {
			console.log('test');
			var iframes = $('iframe');

			$('iframe[src*="vimeo.com"]').each(function () {
        $f(this).api('pause');
    	});

		});
	}
});